const BOTTOM_TOLERANCE_PX = 1;

/**
 * Scroll-spy for a scrolling panel of sections: the last section whose top has
 * passed the panel's mid-height, or the last section once scrolled to the bottom
 * (a short last section may never reach the middle).
 */
export const getActiveScrollSection = (
  scroller: HTMLElement,
  sections: HTMLElement[]
): HTMLElement | undefined => {
  const isAtBottom =
    scroller.scrollTop + scroller.clientHeight >=
    scroller.scrollHeight - BOTTOM_TOLERANCE_PX;

  if (isAtBottom) {
    return sections.at(-1);
  }

  const midline =
    scroller.getBoundingClientRect().top + scroller.clientHeight / 2;

  return (
    sections
      .filter((section) => section.getBoundingClientRect().top <= midline)
      .at(-1) ?? sections[0]
  );
};
